import React, {Component} from 'react';

export const EmptyList = ({type}) => {

    if(type === 1){
        return (
            <div className="text-center">
                <div className="mb-3"><img src="/cashier/shop/static/assets/images/img-empty.svg" alt=""/></div>
                <div className="txtGray">Chưa có giao dịch nào</div>
            </div>
        )
    }

    return (
        <div className="text-center">
            <div className="ml-auto mr-auto" style={{
                backgroundImage: `url(${"/cashier/shop/static/assets/images/img-empty.svg"})`,
                backgroundSize: "100% 100%",
                width: "220px",
                height: "270px",
            }}>
                {/* <img src="/cashier/shop/static/assets/images/img-empty.svg" alt=""/> */}
            </div>
            <div className="txtGray">Chưa có giao dịch nào</div>
        </div>
    );
}